if (!customElements.get('image-banner')) {
  customElements.define(
    'image-banner',
    class ImageBanner extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest('section');
        this.header = document.querySelector('.wt-header');
        this.isMobile = window.matchMedia('(max-width: 899px)').matches;
        this.logoWrapper = this.header?.querySelector('.wt-header__logo');
        this.showLogoClass = 'wt-header__logo--show';
      }

      connectedCallback() {
        this.init();

        document.addEventListener('shopify:section:load', this.handleAdminEditing.bind(this));
        document.addEventListener('shopify:section:unload', this.handleAdminEditing.bind(this));
        document.addEventListener('shopify:section:reorder', this.handleAdminEditing.bind(this));
      }

      handleAdminEditing() {
        this.init();
      }

      init() {
        // Re-query the header in case it wasn't ready before
        this.header = document.querySelector('.wt-header');
        this.logoWrapper = this.header?.querySelector('.wt-header__logo');

        const enabled = this.isTransparentHeaderEnabled();

        if (enabled) {
          this.setTopMargin();
          this.observeHeader();
          this.logoWrapper?.classList.add(this.showLogoClass);
        } else {
          this.resetTopMargin();
          this.logoWrapper?.classList.remove(this.showLogoClass);
        }
      }

      removeObserver() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }

      resetTopMargin() {
        this.section.style.marginTop = '0';
      }

      disconnectedCallback() {
        this.logoWrapper?.classList.remove(this.showLogoClass);
        this.removeObserver();

        if (this.scrollListener) {
          document.removeEventListener('scroll', this.scrollListener);
          this.scrollListener = null;
        }

        document.removeEventListener('shopify:section:load', this.handleAdminEditing.bind(this));
        document.removeEventListener('shopify:section:unload', this.handleAdminEditing.bind(this));
        document.removeEventListener('shopify:section:reorder', this.handleAdminEditing.bind(this));
      }

      observeHeader() {
        const header = document.querySelector('.wt-header');
        const activeTransparentClass = 'wt-header--transparent';
        const transparentLogoClass = 'wt-header--transparent-logo';

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                header.classList.remove(activeTransparentClass);
                header.classList.remove(transparentLogoClass);
              } else {
                header.classList.add(activeTransparentClass);
                // Only add transparent logo class if show_transparent_logo is true
                if (this.shouldShowTransparentLogo()) {
                  header.classList.add(transparentLogoClass);
                }
              }
            });
          },
          { root: null, threshold: 0.05 }
        );

        this.observer.observe(this);
      }

      isValidSectionsOrder() {
        const main = document.querySelector('main');
        const currentSection = this.section;

        if (main && currentSection) {
          const firstSection = main.querySelector('section');
          const isFirst = firstSection === currentSection;

          return isFirst;
        }
        return false;
      }

      isTransparentHeaderEnabled() {
        const header = document.querySelector('.wt-header');
        const transparentHeaderEnabled = this.dataset.transparentHeaderEnabled === 'true';

        return (
          header?.dataset.transparent &&
          this.isValidSectionsOrder() &&
          header.classList.contains('wt-header--v3') &&
          transparentHeaderEnabled
        );
      }

      shouldShowTransparentLogo() {
        // Check if the section has show_transparent_logo setting
        const showTransparentLogo = this.dataset.showTransparentLogo === 'true';
        return showTransparentLogo;
      }

      calculateOffset() {
        const header = document.querySelector('header');
        const headerHeight = header?.offsetHeight || 0;

        const announcement = document.querySelector('.wt-announcement');
        const announcementHeight = announcement ? announcement.offsetHeight : 0;
        const extraPixels = 4; // Add extra pixels to eliminate white space
        const offset = this.isTransparentHeaderEnabled() ? headerHeight + extraPixels : 0;

        return offset;
      }

      setTopMargin() {
        const offset = this.calculateOffset();
        this.section.style.marginTop = `-${offset}px`;
      }
    }
  );
}
